<template>
  <template v-if="theme">
    <section :id="sectionId">
      <Padding :padding="theme.padding">
        <slot />
      </Padding>
    </section>
  </template>
  <template v-else>
    <section :id="sectionId">
      <slot />
    </section>
  </template>
</template>

<script lang="ts" setup>
import type { ImageTheme } from '~/sanity/types';
const props = defineProps<{ theme?: ImageTheme }>();
const { sectionId } = toRefs(props.theme!);
</script>

<style scoped></style>
